import Glide from '@glidejs/glide';
document.addEventListener('DOMContentLoaded', function() {
     /**
         * Glide sliders
         */

        let glides = [];
        let glideElements = document.querySelectorAll('[data-behaviour="glide"]');
        if(glideElements) {
            glideElements.forEach(function (elem, index) {
                var type = elem.getAttribute('data-glide-type');
                var count = elem.getAttribute('data-glide-count');
                var autoPlay = elem.getAttribute('data-glide-auto-play');
                var slideCount = elem.querySelectorAll("li").length;
                var breakpoints = {};
                var gap = (elem.getAttribute('data-glide-slide-gap') != null) ? elem.getAttribute('data-glide-slide-gap') : 30;
                var peek = (elem.getAttribute('data-glide-slide-peek') != null) ? elem.getAttribute('data-glide-slide-peek') : 20;

                if (count >= 3) {
                    breakpoints = {
                        1200: {
                            perView: 4
                        },
                        1024: {
                            perView: 3
                        },
                        600: {
                            perView: 1
                        }
                    }
                }
                if (count == 2) {
                    breakpoints = {
                        1024: {
                            perView: 2
                        },
                        600: {
                            perView: 1
                        }
                    }
                }
                if (window.matchMedia("(max-width: 767px)").matches) {
                    count = 1;

                }
                var args_base = {
                    //type: 'carousel',
                    type: type,
                    gap: gap,
                    animationTimingFunc: "ease",
                    perView: count,
                    rewind: false,
                    swipeThreshold: (slideCount == 1) ? false : 80,
                    dragThreshold: (slideCount == 1) ? false : 120,
                    peek: {
                        before: 0,
                        after: peek
                    },
                    loop:true,
                    breakpoints: breakpoints,
                    autoplay: (autoPlay == "true") ? 5000 : 0
                };

                let args = Object.assign({}, args_base);

                var glide = new Glide(elem, args);
                glides.push(glide);
                glides[index].mount();
            });
        }

        let pagers = document.querySelectorAll('.case-study__pager');
        if(pagers) {
            pagers.forEach((i) => {
                i.setAttribute('data-glide-dir', ">");

            })
        }

});